module.exports = __webpack_public_path__ + "static/media/error-warning-fill.02a50adc.svg";